/**
 * Cognito Configuration
 * Reads Cognito settings from Vite environment variables
 */

export const COGNITO_CONFIG: { UserPoolId: string; ClientId: string } = {
  UserPoolId: (import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined) || '',
  ClientId: (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) || '',
};

/**
 * Whether Cognito auth is configured (all required env vars present)
 */
export function isCognitoConfigured(): boolean {
  return Boolean(COGNITO_CONFIG.UserPoolId && COGNITO_CONFIG.ClientId);
}
